import script from "./report-icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./report-icon.vue?vue&type=script&lang=ts&setup=true"

import "./report-icon.vue?vue&type=style&index=0&id=31a6a2ac&lang=less"

const __exports__ = script;

export default __exports__